module.exports = __webpack_public_path__ + "img/pipedream.84968952.png";